import { Link } from 'react-router-dom';
import { Compass, Home } from 'lucide-react';

// Replaces the silent "redirect to /" catch-all with a branded dead-end
// screen, so users who hit a broken link (from an email, a stale
// bookmark, etc.) know what happened instead of being quietly bounced
// to the dashboard.

export function NotFoundPage() {
  return (
    <div className="min-h-screen flex items-center justify-center p-6 bg-gradient-to-br from-slate-50 to-indigo-50">
      <div className="max-w-md w-full bg-white rounded-2xl shadow-xl p-8 text-center">
        <div className="mx-auto h-14 w-14 rounded-full bg-indigo-50 flex items-center justify-center mb-5">
          <Compass className="h-7 w-7 text-[#6366F1]" />
        </div>
        <p className="text-5xl font-extrabold text-[#6366F1] mb-2">404</p>
        <h1 className="text-lg font-bold text-slate-900 mb-2">Page not found</h1>
        <p className="text-sm text-slate-500 mb-5">
          The page you're looking for doesn't exist or has moved. Check the URL, or head back to
          the dashboard.
        </p>
        <Link
          to="/dashboard"
          className="inline-flex items-center gap-2 px-4 py-2 rounded-lg bg-[#6366F1] hover:bg-[#4F46E5] text-white text-sm font-semibold"
        >
          <Home className="h-4 w-4" /> Back to dashboard
        </Link>
      </div>
    </div>
  );
}
